import React, {PureComponent} from "react"
import {injectIntl, InjectIntl} from "@irati/utils/lang"
import PhoneInput, {PhoneInputProps} from "@irati/ui/src/FormItem/PhoneInput"

interface Props extends InjectIntl, PhoneInputProps {
  onChange(value: string): void,
  value?: string
}

class MFAPhoneNumber extends PureComponent<Props> {
  render() {
    const label = this.props.label || this.props.formatMessage({id: "platform.mfa.phoneNumber.label"})
    return <PhoneInput required id="mfaPhoneNumber" label={label} autoFocus {...this.props} />
  }
}

export default injectIntl(MFAPhoneNumber)
